import React from 'react';
import PropTypes from 'prop-types';
import ClipboardButton from 'react-clipboard.js';
import {Message, ExternalLink} from '@aperza/react-ui';

export default class ClipMenu extends React.Component {

  static propTypes = {
    menuType: PropTypes.string,
    serviceId: PropTypes.number,
    disabledLinks: PropTypes.bool,
    itemPageShown: PropTypes.bool,
    clickOpenMailClip: PropTypes.func,
    clickOpenClip: PropTypes.func,
    clipBoardSuccess: PropTypes.func,
    clipTitle: PropTypes.string,
    clipUrl: PropTypes.string,
  };

  static defaultProps = {
    disabledLinks: false,
    itemPageShown: false,
  };

  constructor(props) {
    super(props);
    this.state={
      hover:false
    }
    this.mouseOver = this.mouseOver.bind(this);
    this.mouseOut = this.mouseOut.bind(this);
    this.mouseBalloonOver = this.mouseBalloonOver.bind(this);
    this.mouseBalloonOut = this.mouseBalloonOut.bind(this);
  }

  mouseOver  = (e) => {
    if( !this.state.hover ) {
      this.refs.balloon.style.display = "block";
      this.setState({hover: true});
    }
  }

  mouseOut  = (e) => {
    let that = this;
    setTimeout(function(){
      if( !that.state.hover ){
        if( that.refs.balloon.style.display === "block"){
          that.refs.balloon.style.display="none";
        }
      }
    },3000);
  }

  mouseBalloonOver = (e) => {
    if( !this.state.hover ){
      this.setState({hover : true});
    }
  }

  mouseBalloonOut = (e) => {
    if( this.state.hover ){
      this.setState({hover : false});
    }
  }

  render(){
    let td_clip_action= this.props.serviceId == 3 ? "aperza_clip_product" :
                        this.props.serviceId == 5 ? "catalog_clip_catalog" : "mnews_clip";
    let td_mail_clip_action = this.props.serviceId == 3 ? "aperza_clip_mail" :
                        this.props.serviceId == 5 ? "catalog_clip_mail" : "mnews_clip_email";
    let td_clipboard_action = this.props.serviceId == 3 ? "aperza_clip_clipboard" :
                        this.props.serviceId == 5 ? "catalog_clip_clipboard" :  "mnews_clip_clipboard";

    let itemPageShown = this.props.itemPageShown;

    let clipSearchClipText1 = itemPageShown === false ? "clip.search.clip.1" : "item.clip.search.clip.1";
    let clipSearchClipText2 = itemPageShown === false ? "clip.search.clip.2" : "item.clip.search.clip.2";
    let clipSearchEmailText1 = itemPageShown === false ? "clip.search.email.1" : "item.clip.search.email.1";
    let clipSearchEmailText2 = itemPageShown === false ? "clip.search.email.2" : "item.clip.search.email.2";
    let clipSearchUrlText1 = itemPageShown === false ? "clip.search.url.1" : "item.clip.search.url.1";
    let clipSearchUrlText2 = itemPageShown === false ? "clip.search.url.2" : "item.clip.search.url.2";

    let clipboardButtonContents = [];
    clipboardButtonContents.push(<span className="icon icon-s icon-copy icon-link inline left"></span>);
    clipboardButtonContents.push(<Message messageId={clipSearchUrlText1}/>);
    clipboardButtonContents.push(<Message messageId={clipSearchUrlText2}/>);

    let disabledLinks = this.props.disabledLinks;
    let clipboardButton;
    if (this.props.disabledLinks === false) {
      clipboardButton = (
        <p>
          <ClipboardButton component="a" data-tracking-action={td_clipboard_action}  data-clipboard-text={this.props.clipTitle + "\r\n" + this.props.clipUrl}  onSuccess={this.props.clipBoardSuccess}>
            {clipboardButtonContents}
          </ClipboardButton>
        </p>
      )
    } else {
      clipboardButton = (
        <p>
          <a href="#" target="_self">
            {clipboardButtonContents}
          </a>
        </p>
      )
    }

    if( this.props.menuType === "popup" ) {
      return(
        <ul className="shareBtns">
          <li className="shareBtns_clip" onMouseOver={this.mouseOver} onMouseOut={this.mouseOut}>
            <img src={STATIC_RESOURCE_URL + "common/images/img_clip.svg"} alt="clip "/>
            <ul className="shareBtns_balloon" ref="balloon" onMouseOver={this.mouseBalloonOver} onMouseOut={this.mouseBalloonOut}>
              <li>
                <ExternalLink
                  dataTrackingAction={td_clip_action}
                  onClick={this.props.clickOpenClip}
                  disabled={disabledLinks}
                >
                 <span className="icon icon-white icon-clip"></span>CLIP
                </ExternalLink></li>
              <li>
                <ExternalLink
                  data-tracking-action={td_mail_clip_action}
                  onClick={this.props.clickOpenMailClip}
                  disabled={disabledLinks}
                >
                  <span className="icon icon-white icon-mail"></span>Mail
                </ExternalLink>
              </li>
              <li>
                <a
                  ref="bookmarkLink"
                  href={this.props.clipUrl}
                  rel="sidebar"
                  data-tracking-action="mnews_bookmark"
                  onClick={this.props.addBookmark}
                >
                  <span className="icon icon-white icon-windowPlus"></span>BookMark
                </a>
              </li>
            </ul>
          </li>
          <li className="shareBtns_snsCount"><span className="icon icon-share"></span></li>
          {this.props.children}
        </ul>
      )
    }else if( this.props.menuType === "view"){
      return(
        <div className="td_aperza_component_clip">
          <ExternalLink dataTrackingAction={td_clip_action} onClick={this.props.clickOpenClip} disabled={disabledLinks}>
            <span className="ac custom-icon clip-clip"></span>
            <Message messageId="clip.search.clip.3"/>
          </ExternalLink>
          <ExternalLink data-tracking-action={td_mail_clip_action} onClick={this.props.clickOpenMailClip} disabled={disabledLinks}>
            <span className="ac custom-icon clip-mail"></span>
            <Message messageId="clip.search.email.3"/>
          </ExternalLink>
          {this.props.children}
        </div>
      )
    }else{
      return (
        <div className="td_aperza_component_clip">
          <p>
            <ExternalLink dataTrackingAction={td_clip_action} onClick={this.props.clickOpenClip} disabled={disabledLinks}>
              <span className="icon icon-s icon-link icon-clip inline left"></span><Message messageId={clipSearchClipText1}/><Message messageId={clipSearchClipText2}/>
            </ExternalLink>
          </p>
          <p>
            <ExternalLink data-tracking-action={td_mail_clip_action} onClick={this.props.clickOpenMailClip} disabled={disabledLinks}>
              <span className="icon icon-s icon-link icon-mail inline left"></span><Message messageId={clipSearchEmailText1}/><Message messageId={clipSearchEmailText2}/>
            </ExternalLink>
          </p>
          {clipboardButton}
          {this.props.children}
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./ClipMenu.js